import { DateTime } from "luxon";

export enum PatternStatus {
  Designed = 0,
  Drilling = 1,
  Drilled = 2,
  Charging = 3,
  Charged = 4,
  Fired = 5,
  Closed = 6,
  Cancelled = 7,
}

export const PATTERN_STEPS = [
  PatternStatus.Designed,
  PatternStatus.Drilling,
  PatternStatus.Drilled,
  PatternStatus.Charging,
  PatternStatus.Charged,
  PatternStatus.Fired,
  PatternStatus.Closed,
];

export enum PatternShape {
  Square = 0,
  Staggered = 1,
}

export enum InitiationSystem {
  Electronic = 0,
  NonElectric = 1,
  Electric = 2,
  Mixed = 3,
}

export const INITIATION_LABELS: Record<InitiationSystem, string> = {
  [InitiationSystem.Electronic]: "Electronic",
  [InitiationSystem.NonElectric]: "Non-electric",
  [InitiationSystem.Electric]: "Electric",
  [InitiationSystem.Mixed]: "Mixed",
};

export enum PatternMoveKind {
  Forward = 0,
  Back = 1,
  Cancel = 2,
  Reopen = 3,
}

export interface PatternDesignDTO {
  benchRl?: number | null;
  benchHeightM?: number | null;
  burdenM?: number | null;
  spacingM?: number | null;
  subdrillM?: number | null;
  stemmingM?: number | null;
  stemmingMaterial?: string | null;
  patternShape?: PatternShape | null;
  designBitSizeId?: number | null;
  designHoleCount?: number | null;
  designMetres?: number | null;
  freeFaces?: number | null;
  designExplosiveKg?: number | null;
  designPowderFactor?: number | null;
  designMicKg?: number | null;
  initiationSystem?: InitiationSystem | null;
  rockDensity?: number | null;
  materialDescription?: string | null;
  plannedFireAt?: DateTime | null;
  rowVersion?: string | null;
}

export interface PatternProgressDTO {
  holesDrilled: number;
  metresDrilled: number;
  redrillMetres: number;
  drillingShifts: number;
  firstDrilled?: DateTime | null;
  lastDrilled?: DateTime | null;
  openMisfires: number;
}

export interface PatternDerivedDTO {
  designVolumeBcm?: number | null;
  designPowderFactor?: number | null;
  designKgPerTonne?: number | null;
}

export interface PatternMoveOptionDTO {
  to: PatternStatus;
  label: string;
  kind: PatternMoveKind;
}

export interface PatternDetailDTO {
  id: number;
  reference: string;
  pitName?: string | null;
  pitStage?: string | null;
  blastTypeName?: string | null;
  status: PatternStatus;
  blastDate?: DateTime | null;
  closedAt?: DateTime | null;
  designSource: number;
  designFileName?: string | null;
  bcm: number;
  tonnes: number;
  canEdit: boolean;
  design: PatternDesignDTO;
  derived: PatternDerivedDTO;
  progress: PatternProgressDTO;
  moves: PatternMoveOptionDTO[];
}

export interface PatternMoveRequest {
  to: PatternStatus;
  blastDate?: string | null;
  acknowledge: boolean;
  rowVersion?: string | null;
}

export interface PatternMoveResultDTO {
  moved: boolean;
  warnings: string[];
  pattern: PatternDetailDTO;
}

export interface PatternDiggingExcavatorDTO {
  plantId: number;
  plantRef: string;
  shifts: number;
  loads: number;
  tonnes: number;
  lastDug: DateTime;
}

export interface PatternDiggingShiftDTO {
  date: DateTime;
  shift: string;
  plantId: number;
  plantRef: string;
  loads: number;
  tonnes: number;
}

export interface PatternDiggingDTO {
  patternBlastId: number;
  blastedTonnes: number;
  dugTonnes: number;
  remainingTonnes?: number | null;
  firstDug?: DateTime | null;
  lastDug?: DateTime | null;
  openMisfires: number;
  excavators: PatternDiggingExcavatorDTO[];
  shifts: PatternDiggingShiftDTO[];
}
